export default "__VITE_ASSET__327b6570__"